module.exports = __webpack_public_path__ + "img/账号一体化.d1e2bc03.png";